import axiosConfig from 'config/axiosConfig'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

function CardSmallCategory() {
    const [loading, setLoading] = useState(true)
    const [category, setCategory] = useState([])

    useEffect(() => {
        let isMounted = true

        axiosConfig.get(`/api/getCategories`).then((res) => {
            if (isMounted) {
                if (res.data.status === 200) {
                    setCategory(res.data.category)
                    setLoading(false)
                }
            }
        })
        return () => {
            isMounted = false
        }
    }, [])

    if (loading) {
        return (
            <div className="text-center">
                <div className="spinner-grow text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    } else {
        var showListCategory = ""
        showListCategory = category.map((item) => {
            const countTutorial = item.tutorials.length

            return (
                <>
                    <ul className="list-group ">
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                            <Link className="list-group-item-action" to={`/tutorial/${item.slug}`}> {item.name}</Link>
                            <span className="badge bg-primary rounded-pill">{countTutorial}</span>
                        </li>
                    </ul>
                </>
            )
        })
    }
    return (
        <div>
            {showListCategory}
        </div>
    )
}

export default CardSmallCategory